import { ThemeEvents } from '@theme/events';
import { morph } from '@theme/morph';
import { Component } from '@theme/component';

/**
 * Keeps the "Estimated restock: DD/MM/YY" bar in sync with the selected
 * variant. Mirrors <product-availability>: the element is always present so
 * there is a stable morph target, and it collapses via CSS when it has no
 * text inside.
 */
class ProductRestockNotice extends Component {
  /** @type {WeakSet<Event>} Deduplicates events across section and document listeners */
  #processedEvents = new WeakSet();

  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateNotice);
    document.addEventListener(ThemeEvents.variantUpdate, this.updateNotice);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateNotice);
    document.removeEventListener(ThemeEvents.variantUpdate, this.updateNotice);
  }

  /**
   * Replaces the notice contents with the newly selected variant's markup.
   * @param {CustomEvent} event - The variant update event.
   */
  updateNotice = (event) => {
    if (this.#processedEvents.has(event)) return;
    this.#processedEvents.add(event);

    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newNotice = event.detail.data.html.querySelector('product-restock-notice');

    if (!newNotice) return;

    morph(this, newNotice.cloneNode(true), { childrenOnly: true });
  };
}

if (!customElements.get('product-restock-notice')) {
  customElements.define('product-restock-notice', ProductRestockNotice);
}
